import { render, staticRenderFns } from "./huanxinExpression.vue?vue&type=template&id=1a8fa250&scoped=true&"
import script from "./huanxinExpression.vue?vue&type=script&lang=js&"
export * from "./huanxinExpression.vue?vue&type=script&lang=js&"
import style0 from "./huanxinExpression.vue?vue&type=style&index=0&id=1a8fa250&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8fa250",
  null
  
)

export default component.exports